import { BaseParameterDto } from '../../../../../_models/base-parameter-dto';

export class ARInvoiceWaiveParameterDto extends BaseParameterDto {
    communityId: number;
    managementCompanyId: number;
    invoiceId: string;
    waiveReason: string;
}
